<template>
  <nav>
    <h3 class="a11y-hidden">서브 메뉴 네비게이션</h3>
    <ul class="sub-list">
      <li v-for="(subMenu, index) in subMenuListByParentMenu" :key="'subMenu_' + index" :class="subMenu.class">
        <a href="#" :data-index="subMenu.index" @click="()=>changeSubMenu(subMenu)"
           :class="subMenu.index === +menuIndex ? 'on' : ''">{{subMenu.title}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'MyPooqSubMenu',
  props: ['parentIndex', 'menuIndex', 'changeMenuFn'],
  data () {
    return {
      subMenuList: {
        '0': [ // 이용내역
          { index: 0, title: 'VOD 시청내역', path: '/mypooq/use_list_vod_history', class: '' },
          { index: 1, title: '영화 시청내역', path: '/mypooq/use_list_movie_history', class: '' },
          { index: 2, title: '다운로드 내역', path: '/mypooq/use_list_download', class: '' }
        ],
        '2': [ // 좋아요
          { index: 0, title: '채널', path: '/mypooq/like_channel', class: 'sub-like-channel' },
          { index: 1, title: '에디터Pick', path: '/mypooq/like_theme', class: 'sub-like-channel' }
        ],
        '6': [ // 구매콘텐츠
          { index: 0, title: '단건', path: '/mypooq/voucher_list_singular', class: '' },
          { index: 1, title: '패키지', path: '/mypooq/voucher_list_package', class: '' }
        ],
        '8': [
          { index: 0, title: '코인내역', path: '/mypooq/coin', class: '' },
          { index: 1, title: '보유쿠폰', path: '/mypooq/coupon', class: '' }
        ]
      }
    }
  },
  methods: {
    changeSubMenu (subMenu) {
      this.changeMenuFn(subMenu)
    }
  },
  computed: {
    subMenuListByParentMenu () {
      const subMenu = this.subMenuList[this.parentIndex]
      if (subMenu === undefined) return []
      return subMenu
    }
  }
}
</script>

<style scoped>
  .sub-list li.sub-like-channel {
    margin: 0 auto
  }
</style>
